<button class="add-button">
  <span></span>
</button>
